import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Image } from 'react-bootstrap';
import { Link, useParams, useLocation } from 'react-router-dom';
import { fetchWorkshops } from '../redux/actions/productActions';
import LayoutWithSideBar from '../components/LayoutWithSideBar';
import { getWorkshopClasses } from '../lib/product';
import productData from "../data/product.json";

const descLength = 225;

const WORKSHOP_IMAGE_MAP = {
  "introduction-to-climbing-(project-rock-ikea)-workshop": "/assets/images/workshops/ikea-batu-kawan-climb.png",
  "top-rope-course-(ikea)-workshop": "/assets/images/workshops/ikea-top-rope.png",
  "introduction-to-climbing-(project-rock-gurney)-workshop": "/assets/images/workshops/gurney-plaza-climb.png",
  "introduction-to-climbing-(project-rock-bayana)-adult": "/assets/images/workshops/bayana-beginner.png",
  "(4th-april)-seacf-level-1---top-rope-seacf": "/assets/images/workshops/bayana-seacf-lvl1-4.png",
  "(5th-april)-seacf-level-1---top-rope-seacf": "/assets/images/workshops/bayana-seacf-lvl1-5.png",
  "(11th---12th-april)-seacf-level-2---lead-seacf": "/assets/images/workshops/bayana-seacf-lvl2.png",
  "introduction-to-lead-belaying-and-climbing-workshop": "/assets/images/workshops/bayana-climb-lead.png",
  "introduction-to-top-rope-belaying-and-climbing-workshop": "/assets/images/workshops/bayana-top-rope.png"
};

const Desc = ({ description = '' }) => {
  const [isCollapse, setIsCollapse] = useState(true);
  const pElement = useRef();

  const handleClick = () => {
    if (!isCollapse) {
      pElement.current.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
    setIsCollapse(isCollapse => !isCollapse);
  };

  return (
    <p ref={pElement} className="pass-description">
      {description.substring(0, isCollapse ? descLength : undefined)}
      {description.length > descLength &&
        <Fragment>
          {isCollapse && <span> ...</span>}
          <br />
          <span className="pass-read-more" onClick={handleClick}>
            {isCollapse ? 'Read more' : 'Read less'}
          </span>
        </Fragment>
      }
    </p>
  )
}

const Classes = () => {
  const dispatch = useDispatch();
  const workshops = useSelector(state => state.productData.workshops);
  const [siteWorkshops, setSiteWorkshops] = useState([]);

  useEffect(() => {
    dispatch(fetchWorkshops());
  }, [dispatch]);

  let { gym } = useParams();
  const { pathname } = useLocation();
  const path = pathname.split('/')[1];

  useEffect(() => {
    setSiteWorkshops(
      getWorkshopClasses(workshops, path, gym.replace(/-/g, " ").toLowerCase())
    );
  }, [workshops, path, gym]);

  if (!workshops || Object.keys(workshops).length === 0) {
    return (
      <LayoutWithSideBar>
        <div className="text-center">
          <h3>Loading...</h3>
        </div>
      </LayoutWithSideBar>
    );
  }

  return (
    <LayoutWithSideBar>
      {siteWorkshops && siteWorkshops.length > 0 ? (
        siteWorkshops.map((ws, i) => {
          const wsUrl = ws._id.replace(/\s+/g, "-").toLowerCase();
          return (
            <Row key={i} className="space-pb-30 align-items-center">
              <Col md={5} sm={12}>
                <Link to={`/workshop/${gym}/${wsUrl}`}>
                  <Image
                    src={WORKSHOP_IMAGE_MAP[ws?.variants?.[0]?.sku] || `https://placehold.co/500x220/E5E7EB/4B5563?text=${encodeURIComponent(ws._id)}`}
                    alt={`${ws._id}`}
                    className="pass-types"
                    onError={(e) => {
                      //  e.target.src = `https://placehold.co/500x220?text=${encodeURIComponent(ws._id)}`;
                      e.target.src = `https://placehold.co/500x220/E5E7EB/4B5563?text=${encodeURIComponent(ws._id)}`;
                    }}
                    fluid
                  />
                </Link>
              </Col>
              <Col md={7} sm={12} className="space-mt-10">
                <Desc key={i} description={ws.variants[0].desc || ws._id} />
              </Col>
            </Row>
          );
        })
      ) : (
        <div className="text-center">
          <h3>No workshop available now.</h3>
          <p>Please stay tuned for updates!</p>
        </div>
      )}
    </LayoutWithSideBar>
  );
};

export default Classes;
